import Vue from 'vue'

Vue.mixin({
  methods: {
    async refreshToken() {
      let expiryToken = this.$moment(this.$cookies.get('wegow.expiry_token')).subtract(30, 'seconds')
      if (this.$cookies.get('wegow.refresh_token') && this.$cookies.get('wegow.expiry_token') && expiryToken.isBefore(this.$moment())) {
        await this.axios
          .post(`/jwt/token/refresh/`, {
            refresh: $cookies.get('wegow.refresh_token')
          })
          .then(res => {
            this.$cookies.set('wegow.access_token', res.data.access_token)
            this.$cookies.set('wegow.expiry_token', res.data.expiry_token)
          })
      } else {
        this.cleanToken()
      }
    },
    cleanToken() {
      this.$cookies.remove('wegow.access_token')
      this.$cookies.remove('wegow.refresh_token')
      this.$cookies.remove('wegow.expiry_token')
    }
  }
})
